import React from "react";
import { StyleSheet, View } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import ErrorText from "./ErrorText";

const SummaryData = ({ summary, disabled_reason_submit }) => {
  return (
    <View style={styles.container}>
      <View style={styles.summaryContainer}>
        <Text variant="title_16" style={styles.title}>
          {summary?.title}
        </Text>
        <View style={styles.listContainer}>
          {summary?.list?.map((item, index) => (
            <View style={styles.itemContainer} key={item.name}>
              <Text variant="caption_2" style={styles.itemName}>
                {item.name}
              </Text>
              <Text variant="body_text_2" style={styles.itemValue}>
                {item.value}
              </Text>
            </View>
          ))}
        </View>
      </View>
      {disabled_reason_submit && (
        <View style={{ marginBottom: 8 }}>
          <ErrorText text={disabled_reason_submit} />
        </View>
      )}
    </View>
  );
};

export default SummaryData;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    padding: 16,
    paddingVertical: 0,
    flexDirection: "column",
  },
  summaryContainer: {
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    borderRadius: 8,
  },
  title: {
    color: color.mediumBlack,
  },
  listContainer: {
    marginVertical: 8,
  },
  itemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 4,
    marginHorizontal: 4,
  },
  itemName: {
    color: color.black06,
  },
  itemValue: {
    color: color.black,
  },
});
